import React from "react";
import { Carousel } from "react-bootstrap";
import getStartedImage from "../@assets/steps.svg"; // replace with your image path

const AgencyStepsCarousel = () => {
  return (
    <div className="mt-5">
      <div className="text-center my-5">
        <h4 style={{ color: "#343a40", fontWeight: "700" }}>Get Started in 3 Simple Steps</h4>
      </div>
      <div className="border-0 w-75 rounded-4 py-5 m-auto bg-light shadow-lg position-relative">
        <Carousel
          interval={null}
          indicators={false}
          nextIcon={<span aria-hidden="true" className="carousel-control-next-icon" />}
          prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon" />}
          className="carousel-dark"
        >
          <Carousel.Item>
            <div className="d-flex justify-content-center align-items-center gap-5">
              <div className="d-flex align-items-center">
                <div className="bg-white p-4 rounded-4 shadow-sm">
                  <div className="d-flex gap-4 align-items-center">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#9B59B6",
                        borderRadius: "50%",
                        fontSize: "1.5rem",
                        color: "white",
                        fontWeight: "700",
                      }}
                    >
                      1
                    </div>
                    <div>
                      <p
                        className="m-0"
                        style={{ fontSize: "1.3rem", fontWeight: "600", color: "#495057" }}
                      >
                        Create Your Agency Account
                      </p>
                      <p
                        className="m-0 mt-1"
                        style={{ fontSize: "1rem", color: "#6c757d" }}
                      >
                        Sign up and set up your profile in minutes.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <img src={getStartedImage} width={300} alt="getStarted" />
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="d-flex justify-content-center align-items-center gap-5">
              <div className="d-flex align-items-center">
                <div className="bg-white p-4 rounded-4 shadow-sm">
                  <div className="d-flex gap-4 align-items-center">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#9B59B6",
                        borderRadius: "50%",
                        fontSize: "1.5rem",
                        color: "white",
                        fontWeight: "700",
                      }}
                    >
                      2
                    </div>
                    <div>
                      <p
                        className="m-0"
                        style={{ fontSize: "1.3rem", fontWeight: "600", color: "#495057" }}
                      >
                        Link Your Partner Universities
                      </p>
                      <p
                        className="m-0 mt-1"
                        style={{ fontSize: "1rem", color: "#6c757d" }}
                      >
                        Connect all your university partners to your dashboard.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <img src={getStartedImage} width={300} alt="getStarted" />
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="d-flex justify-content-center align-items-center gap-5">
              <div className="d-flex align-items-center">
                <div className="bg-white p-4 rounded-4 shadow-sm">
                  <div className="d-flex gap-4 align-items-center">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#9B59B6",
                        borderRadius: "50%",
                        fontSize: "1.5rem",
                        color: "white",
                        fontWeight: "700",
                      }}
                    >
                      3
                    </div>
                    <div>
                      <p
                        className="m-0"
                        style={{ fontSize: "1.3rem", fontWeight: "600", color: "#495057" }}
                      >
                        Start Processing Applications
                      </p>
                      <p
                        className="m-0 mt-1"
                        style={{ fontSize: "1rem", color: "#6c757d" }}
                      >
                        Upload student details and generate payment links instantly.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <img src={getStartedImage} width={300} alt="getStarted" />
              </div>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
};

export default AgencyStepsCarousel;
